module.exports = __webpack_public_path__ + "img/dsci0123.234d0b7f.jpg";